function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-673c4347-c960-4276-a4ea-796f6ed5fd7c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.875,4.635c0-.829-.672-1.5-1.5-1.5h-10.75c-.828,0-1.5.671-1.5,1.5v17.572c0,.008.002.016.002.024,0,.013.003.026.004.039.008.187.046.366.116.53.002.005.006.009.008.015.079.177.19.336.328.469.003.003.004.006.006.009l5.413,5.158c.01.009.022.011.032.02.135.123.285.221.446.285.011.004.022.006.033.01.168.063.345.098.523.099,0,0,0,0,0,0h0s0,0,0,0c.18,0,.358-.036.528-.1.011-.004.021-.006.032-.01.163-.065.313-.165.448-.289.01-.009.023-.012.033-.021l5.337-5.158s.002-.005.005-.007c.139-.136.253-.299.331-.481,0-.002.002-.003.002-.005.071-.166.109-.349.115-.54,0-.01.003-.02.003-.03,0-.006.002-.011.002-.017V4.635Zm-6.844,20.651l-3.906-3.722V6.135h7.75v15.436l-3.844,3.716Z",
    style: {
      fill: "#d8d8d8"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/Marker.c62dcb9d1b947ea075738b05addcdef0.svg";
export { ForwardRef as ReactComponent };